import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import './styles/app.css';
// Token colors for highlight.js output (`useMarkdown.ts` renders code blocks
// with `hljs-*` classes but supplies no color rules of its own). Monokai
// matches the Pygments "monokai" theme used by the Jinja fallback's
// server-side rendering, so both UIs render code with the same palette.
import 'highlight.js/styles/monokai.css';

createApp(App).use(router).mount('#app');
